import { firstLetterUpper } from 'projects/common/src/app/services/utils/utilities';
/* eslint-disable no-useless-escape */
/* eslint-disable prettier/prettier */
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BusyState } from 'projects/common/src/app/classes';
import { IResponseError } from 'projects/common/src/app/interfaces/communication/response';
import { BooleanStateService } from 'src/app/modules/core/services/boolean-state.service';
import { GoogleAnalyticsService } from 'src/app/modules/core/services/google/google-analytics.service';
import { LanguageService } from '../../../../../../projects/common/src/app/services/parameters';
import { LoginService } from '../../services';
import { communicationServiceProvider } from '../../services/providers';
import { LoginTriesModalComponent } from '../login-tries-modal/login-tries-modal.component';

@Component({
  selector: 'app-default-login',
  templateUrl: './default-login.component.html',
  styleUrls: ['./default-login.component.scss'],
  providers: [communicationServiceProvider, BooleanStateService],
})
export class DefaultLoginComponent extends BusyState implements OnInit {
  private blurTimeout: any;
  public loginForm: FormGroup;
  public showIconActive: boolean;
  public errorMessage: string | string[];
  public capsOn: boolean;
  public capsLock: string;

  public readonly REGEX_ONLYLETTERANDNUMBERS = '([^a-zA-Záéíóúa-zA-Záéíóú0-9])';
  public readonly REGEX_ONLYLETTERANDNUMBERSANDONEPOINT = '/^[a-zA-ZáéíóúÁÉÍÓÚ0-9]+(.[a-zA-ZáéíóúÁÉÍÓÚ0-9]+)?$/';
  public readonly REGEX_CHARSLETTERANDNUMBERS = '([^a-zA-Záéíóúa-zA-Záéíóú0-9.!#$%&*+/=?^_`{|}~-])';

  constructor(
    private loginService: LoginService,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private progressBarService: BooleanStateService,
    private langService: LanguageService,
    private _googleAnalyticsService: GoogleAnalyticsService,
  ) {
    super();
  }

  /**
   * Initialize app
   */
  public ngOnInit(): void {
    this.capsLock = this.langService.message('caps-lock');
    this.loginForm = this.formBuilder.group({
      username: new FormControl('', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(50)])),
      password: new FormControl('', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(20)])),
    });
    this._googleAnalyticsService.sendPageView('/login');
    /* Se mantiene comentado por si se encuentran casos de modal con códigos de error directamente en el login
    const errorCode = this.cacheService.session('errorCode');
    if (errorCode) {
      const error = this.languageService.message(errorCode, null);
      const componentRef = this.modalService.open(LoginTriesModalComponent, { centered: true });
      componentRef.componentInstance.title = 'unauthorized_account';
      componentRef.componentInstance.message = [error];
      componentRef.result.finally(() => {
        this.cacheService.clearSession('errorCode');
      });
    } */
  }

  /**
   * Submit the login form
   */
  public submit(): void {
    this.errorMessage = null;
    this.loginForm.disable();
    this.progressBarService.start();
    this.loginService
      .login(this.loginForm.value)
      .then(
        () => {},
        (responseError: IResponseError) => {
          let message: string[];

          if (responseError.description.match(/\\n/gi)) {
            message = responseError.description.split('\\n');
          } else {
            message = [responseError.description];
          }
          // this.modalOpen(responseError.errorCode, responseError.description);
          if (responseError.errorCode === 'M001' || responseError.errorCode === 'M004') {
            this.errorMessage = message;
          } else {
            const componentRef = this.modalService.open(LoginTriesModalComponent, { centered: true });
            // TODO: Enviar título y mensaje por definir
            componentRef.componentInstance.title = responseError.errorCode === 'M079' ? 'limit-session' : 'banned_account';
            componentRef.componentInstance.message = message;
            componentRef.result.then(() => {
              this.errorMessage = '';
            });
          }
        },
      )
      .finally(() => {
        this.loginForm.enable();
        this.progressBarService.stop();
      });
  }

  public validateNoStartOrEndWithDotRegex(name: string): boolean {
    // Asegurarse que no hay puntos consecutivos, ni punto al inicio, ni punto al final
    return /^(?!.*\.\.)(?!^\.)[a-zA-Z0-9]*(?:\.[a-zA-Z0-9]+)*$/.test(name);
  }

  public validateNoStartOrEndWithDot($event: KeyboardEvent): void {
    const inputElement = $event.target as HTMLInputElement;
    const futureValue = inputElement.value + $event.key;
    const containsDot = inputElement.value.includes('.');

    // Prevenir la entrada de un punto si es la primera tecla presionada o si hay un punto al final ya
    if ($event.key === '.' && (inputElement.value.trim() === '' || inputElement.value.endsWith('.'))) {
      $event.preventDefault();
      return;
    }

    // Comprobación de puntos al inicio, al final o consecutivos si ya la cadena de texto contiene un punto
    if (containsDot) {
      if (!this.validateNoStartOrEndWithDotRegex(futureValue) && $event.key !== 'Backspace') {
        $event.preventDefault();
      }
    }
  }

  /**
   * Validate chars letters username
   */
  public validateChars($event: KeyboardEvent): void {
    if ($event.key.match(this.REGEX_CHARSLETTERANDNUMBERS) && $event.key !== 'Backspace') {
      $event.preventDefault();
    }
  }

  /**
   * Cancel the login request
   */
  public cancelSubmit(): void {
    this.progressBarService.stop();
    this.loginService.cancel();
  }

  /**
   * returns the form control
   */
  public get f(): any {
    return this.loginForm.controls;
  }

  /**
   * Change the password visibility
   */
  public togglePasswordVisibility(input: HTMLInputElement): void {
    input.type = input.type === 'password' ? 'text' : 'password';
    input.focus();
  }

  /**
   * Check if input password is focus to change the image source
   */
  public checkPasswordFocus(input: HTMLInputElement, isImage?: boolean): void {
    if (isImage) {
      clearTimeout(this.blurTimeout);
    } else {
      this.blurTimeout = setTimeout(() => {
        this.showIconActive = false;
        input.type = 'password';
      }, 100);
    }
  }
}
